import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function ReceiptItemInfoComponent({
  handleInnerFormChange, selectedReceipts
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <>
            <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              <InputContainer
                label="Receipt Amount"
                name="ReceiptAmount"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'ReceiptAmount'
                  );
                }}
                type="number"
                value={selectedReceipts?.ReceiptAmount}
              />
              <InputContainer
                label="Paid Amount"
                name="PaidAmount"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'PaidAmount'
                  );
                }}
                type="number"
                value={selectedReceipts?.PaidAmount}
              />
              <InputContainer
                isDisabled={selectedReceipts}
                label="Balance Amount To be Paid"
                name="BalanceAmountTobePaid"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'BalanceAmountTobePaid'
                  );
                }}
                type="number"
                value={selectedReceipts?.BalanceAmountTobePaid}
              />
            </div>
          </>
        }
        expandedPanel="basicInfo"
        headerTitle="Item Information"
      />
    </>
  )
}